import ApiDetails from "./apiDetails";

export default ApiDetails;
